module.exports = __webpack_public_path__ + "new_tag_s.png?06f93b569475f395781af0298609102c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_tag_s.png
// module id = 538
// module chunks = 0